import { useSuspenseInfiniteQuery } from '@tanstack/react-query';
import { fetchChatRoomList } from '~/api';
import { GetChatRoomListData, PaginationRequest } from '~/types';
import { SECOND } from '~/constants';
import chatRoomKey from './chatRoomKey';

export const CHAT_LIST_FETCH_SIZE = 15;

const useGetChatRoomListQuery = () => {
  return useSuspenseInfiniteQuery({
    queryKey: chatRoomKey.getChatList(),
    queryFn: ({ pageParam }) =>
      fetchChatRoomList({
        page: pageParam,
      } as PaginationRequest<void>),
    initialPageParam: 1,
    getNextPageParam: ({ data, status }, _, lastPageParam) => {
      if (status !== 200) return undefined;
      if (data.length < CHAT_LIST_FETCH_SIZE) return undefined;

      const nextPage = lastPageParam + 1;
      return status === 200 && data.length === 0 ? undefined : nextPage;
    },
    select: (response) => {
      return {
        pageParams: response.pageParams,
        pages: response.pages.flatMap((page) => {
          if (page.data) return page.data as GetChatRoomListData[];
          return [];
        }),
      };
    },
    refetchInterval: 20 * SECOND,
    // window focus 안해도 데이터 페칭을 할것인지 default false
    refetchIntervalInBackground: true,
  });
};

export default useGetChatRoomListQuery;
